import PropTypes from 'prop-types';
import { useEffect } from 'react';

import useHistory from 'routing/useHistory';

import Route from './common/Routes';

// https://stackoverflow.com/questions/52912238/render-methods-should-be-a-pure-function-of-props-and-state
const GCPInputConfiguration = ({ url }) => {
  const history = useHistory();

  useEffect(() => {
    history.push(url);
  }, [history, url]);

  return null;
};

GCPInputConfiguration.propTypes = {
  url: PropTypes.string,
};

GCPInputConfiguration.defaultProps = {
  url: Route.INTEGRATIONS.GCP.ACTIVITYAPI.index,
};

export default GCPInputConfiguration;
